import React from 'react';
import ContactBanner from './ContactSection/ContactBanner';
import ContactForm from './ContactFormBox/ContactForm';
import ContactGoogle from './GMB/ContactGoogle';

function Contact() {
  return (
    <>
      <ContactBanner />
      <ContactForm/>
      <ContactGoogle/>
    </>
  )
}

export default Contact
